import React, { createContext, useContext, ReactNode } from 'react';

interface CookieConsentContextType {
  showSettings: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextType | null>(null);

export interface CookieConsentProviderProps {
  children: ReactNode;
  showSettings: () => void;
}

export const CookieConsentProvider: React.FC<CookieConsentProviderProps> = ({ 
  children, 
  showSettings 
}) => {
  return (
    <CookieConsentContext.Provider value={{ showSettings }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsentContext = (): CookieConsentContextType => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    // Don't throw error during SSR or when context is not available
    // Return a no-op function to prevent crashes
    return { showSettings: () => {} };
  }
  return context;
};
